module.exports = __webpack_public_path__ + "static/media/Direct-object-Pronouns-Spanish.8320c5e5.jpeg";